import { render, staticRenderFns } from "./CryptoDotComExchangeInput.vue?vue&type=template&id=6ebb309c&"
import script from "./CryptoDotComExchangeInput.vue?vue&type=script&lang=ts&"
export * from "./CryptoDotComExchangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports